import { HomeScreen } from '@strata/react-page-templates';

export const Home = () => (
    <HomeScreen
        illustration={HomeScreen.Illustration.HEART}
        welcomeMessagePartOne="FMH Oops Website."
        messages={[]}
    />
);
